// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__aj7r+","buttonsWrapper":"styles_buttonsWrapper__R7yx9"};